<template>
  <div class="pnl_wraper">
    <!-- <div class="layer bg" id="login"></div> -->
    <nav class="navbar navbar-dark bg-dark">
      <!-- eslint-disable-next-line vuejs-accessibility/anchor-has-content -->
      <a
        class="navbar-brand icon_log"
        target="_blank"
        href="http://www.ibaibu.com"
      ></a>
      <ul class="navbar-nav">
        <li class="nav-item">
          <a class="nav-link" target="_blank" href="http://www.ibaibu.com"
            >官网</a
          >
        </li>
        <li class="nav-item" v-if="false">
          <a class="nav-link" target="_blank" href="http://www.ibaibu.com"
            >文档</a
          >
        </li>
        <li class="nav-item" v-if="false">
          <a class="nav-link" target="_blank" href="http://www.ibaibu.com"
            >社区</a
          >
        </li>
      </ul>
    </nav>
    <div class="flex-center pnl_content">

      <div class="pnl_desc">
        <!-- <a class="icon_log" target="_blank" href="http://www.ibaibu.com"></a> -->
        <p>百布日志分析系统</p>
        <p>支持100T日志采集分析能力</p>
        <p>提效开发者的指南针</p>
      </div>

      <div class="pnl_login">
        <div class="title">登录</div>
        <div class="pnl_input">
          <el-form :model="form" :rules="rules" ref="form">
            <el-form-item prop="userName">
              <el-input placeholder="请输入用户名" v-model="form.userName" autocomplete="on">
                <i slot="prefix" class="el-input__icon el-icon-user"></i>
              </el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input
                placeholder="请输入密码"
                type="password"
                v-model="form.password"
                autocomplete="on"
              >
                <i slot="prefix" class="el-input__icon el-icon-lock"></i>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="handleSubmit" :loading="loading"
                >提交</el-button
              >
              <el-link type="danger" :underline="false">
                （2022年7月5号起请使用LDAP帐号登录）
              </el-link>
            </el-form-item>
          </el-form>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
// eslint-disable-next-line import/no-cycle
import { login } from '@/api/auth';
import { AUTH_TOKEN } from '@/data/auth';
import { USER_INFO } from '@/data/user';
// import CryptoJS from 'crypto-js';

export default {
  data() {
    return {
      form: {
        userName: '',
        password: '',
      },
      loading: false,
      rules: {
        userName: [
          {
            required: true,
            message: '请输入用户名',
            trigger: 'blur',
          },
        ],
        password: [
          {
            required: true,
            message: '请输入密码',
            trigger: 'blur',
          },
        ],
      },
    };
  },
  methods: {
    handleSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          try {
            this.loading = true;
            const res = await login({
              ...this.form,
              // password: CryptoJS.MD5(this.form.password).toString(),
            });
            const { token } = res.data;
            window.localStorage.setItem(AUTH_TOKEN, token);
            window.localStorage.setItem(USER_INFO, JSON.stringify({
              userName: this.form.userName,
            }));
            // 获取当前用户名称
            this.loading = false;
            this.$router.push('/');
          } catch (e) {
            this.loading = false;
            console.error(e);
          }
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.navbar {
  justify-content: flex-start;

  .icon_log {
    background-size: contain;
    padding-left: 150px;
    height: 40px;
  }

  .navbar-nav {
    position: absolute;
    right: 15px;
    flex-direction: row;
    .nav-link {
      color: #fff;
      opacity: 0.6;
      font-family: Avenir-Medium;
      font-size: 16px;
      font-weight: bold;
      padding-right: 1.5rem;
      padding-left: 0.5rem;
    }
  }
}
.pnl_wraper {
  color: #fff;
  background: url("../assets/black_dot.png") 0% 0% repeat;
  height: 100vh;

  .layer {
    position: absolute;
    height: 100%;
    width: 100%;

    &.flex-center {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
    }
  }

  .pnl_content {
    position: relative;

    .pnl_desc {
      position: absolute;
      top: 200px;
      left: 100px;
      text-align: left;
      width: 500px;
      padding-top: 100px;

      p {
        opacity: 0.8;
        font-size: 24px;
        color: #fff;
        max-width: 780px;
        text-align: left;
        line-height: 40px;
      }

    }
    .pnl_login {
      position: absolute;
      top: 120px;
      right: 100px;

      width: 400px;
      padding: 0 20px 25px;
      background: #fff;
      border-radius: 4px;
      overflow: hidden;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);

      .title {
        margin-top: 30px;
        font-size: 32px;
        color: #000;
      }

      .pnl_input {
        margin-top: 30px;
        /deep/.el-button {
          width: 100%;
        }
      }
    }
  }
}
</style>
